import MultiQuoteActions from "@frameworks/web/redux/feature/TOCJourney/actions/MultiQuoteActions";
import PlaceNormalTradeActions from "@frameworks/web/redux/feature/TOCJourney/actions/PlaceNormalTradeActions";
import OrderDetailsActions from "@frameworks/web/redux/feature/TOCJourney/actions/OrderDetailsActions";
import CheckMarginActions from "@frameworks/web/redux/feature/TOCJourney/actions/CheckMarginActions";
import BrokerChargesActions from "@frameworks/web/redux/feature/TOCJourney/actions/BrokerChargesActions";
import RMSDetailsActions from "@frameworks/web/redux/feature/TOCJourney/actions/RmsDetails";
import AMOStatusActions from "@frameworks/web/redux/feature/TOCJourney/actions/AMOStatusActions";
import ProceedToAuthActions from "@frameworks/web/redux/feature/TOCJourney/actions/ProceedToAuth";
import LimitsActions from "@frameworks/web/redux/feature/TOCJourney/actions/LimitsAction";
import MFParticularHoldingActions from "@frameworks/web/redux/feature/TOCJourney/actions/MFParticularHoldings";
import UserStatusActions from "@frameworks/web/redux/feature/TOCJourney/actions/UserStatusActions";
import UPIListActions from "@frameworks/web/redux/feature/TOCJourney/actions/UPIListActions";
import IpobankMasterActiton from "@frameworks/web/redux/feature/TOCJourney/actions/IpobankMasterActiton";
import IpoOtpValidateActiton from "@frameworks/web/redux/feature/TOCJourney/actions/IpoOtpValidateAction";
import IpoOtpRegisterActiton from "@frameworks/web/redux/feature/TOCJourney/actions/IpoOtpRegisterActions";
import IpoOtpLeadsActiton from "@frameworks/web/redux/feature/TOCJourney/actions/IpoOtpLeadsActions";
import IpoCancelActiton from "@frameworks/web/redux/feature/TOCJourney/actions/IpoCancelAction";
export default () => {
    return {
        tocJourney: {
            multiQuoteActions: new MultiQuoteActions(),
            placeNormalTrade: new PlaceNormalTradeActions(),
            placeOfsTrade: new PlaceNormalTradeActions(),
            placeTradeComm: new PlaceNormalTradeActions(),
            orderDetails: new OrderDetailsActions(),
            checkMargin: new CheckMarginActions(),
            brokerCharges: new BrokerChargesActions(),
            brokerChargesComm: new BrokerChargesActions(),
            rmsDetails: new RMSDetailsActions(),
            amoStatus: new AMOStatusActions(),
            proceedToAuth: new ProceedToAuthActions(),
            limits: new LimitsActions(),
            mfParticularHolding: new MFParticularHoldingActions(),
            userStatus: new UserStatusActions(),
            upiList: new UPIListActions(),
            IpoBankMaster: new IpobankMasterActiton(),
            IpoOtpValidate: new IpoOtpValidateActiton(),
            IpoOtpRegister: new IpoOtpRegisterActiton(),
            IpoOtpLeads: new IpoOtpLeadsActiton(),
            IpoCancel: new IpoCancelActiton(),
        },
    };
};
